/**
 * jarvis-today PH-03e (BACKLOG PH-03 ruling (e), core ruling 2026-11-03 19:13 CT): which approvals Joseph opened from
 * Today's Needs you, so a decide or draft call can say `origin: 'today'` for the usage review. Telemetry only: the
 * server records it and nothing reads it as authentication, authorship or send authority. In memory only, so a
 * reload, a new tab or a pushed link reads as unknown.
 */

const TAP_WINDOW_MS = 5000;

let tap: { id: string; at: number } | null = null;
const fromToday = new Set<string>();
let openInVisit: string | null = null;

/** Today's Needs you link for card `id` was tapped. */
export function noteTodayTap(id: string): void {
  tap = { id, at: Date.now() };
}

/**
 * A visit to the approvals page starts (the page mounted). The card open in the store from an earlier visit is no
 * longer "already open" here, so selecting it again counts as a new open.
 */
export function beginApprovalsVisit(): void {
  openInVisit = null;
}

/**
 * A card opened (null: closed). Marked when a Today tap for this same card is under 5 s old (the tap is used up).
 * Otherwise, selecting the card that is already open in this visit changes nothing (the wide-screen auto-open and the
 * route open can both select the tapped card on one visit); any other open is not from Today, so it is unmarked.
 */
export function openedApproval(id: string | null): void {
  if (id === null) {
    openInVisit = null;
    return;
  }
  if (tap && tap.id === id && Date.now() - tap.at < TAP_WINDOW_MS) {
    tap = null;
    fromToday.add(id);
  } else if (id !== openInVisit) {
    fromToday.delete(id);
  }
  openInVisit = id;
}

/** 'today' for a card opened from Today, else undefined (left out of the request body). */
export function approvalOrigin(id: string): 'today' | undefined {
  return fromToday.has(id) ? 'today' : undefined;
}
